import { Box, Icon, Modal, Slide } from "@mui/material";
import { useNavigate } from "react-router-dom";
import breakpoints from "assets/scss/breakpoints.module.scss";
import styles from "./ModalWrapper.module.scss";

const ModalWrapper = ({ openModal, setOpenModal, children, title, headerContent, sideRail, compactHeader = false, filterPanel = false, back = false, fullScreen = true, bottomSheet = false, sideDrawer = false }) => {
    const navigate = useNavigate();

    const handleClose = () => {
        setOpenModal(false);
        if (back) {
            navigate(-1);
        }
    };

    const sx = sideDrawer
        ? {
              top: "60px",
              bottom: "54px",
              height: "auto",
              "& .MuiBackdrop-root": {
                  top: "60px",
                  bottom: "54px",
                  backgroundColor: "rgba(0, 0, 0, 0.48)",
              },
              [`@media (min-width:${breakpoints.desktopMin})`]: {
                  display: "none",
              },
          }
        : bottomSheet
        ? {
              top: "60px",
              bottom: "54px",
              height: "auto",
              "& .MuiBackdrop-root": {
                  top: "60px",
                  bottom: "54px",
                  backgroundColor: "rgba(0, 0, 0, 0.58)",
              },
              [`@media (min-width:${breakpoints.desktopMin})`]: {
                  display: "none",
              },
          }
        : fullScreen
        ? {
              top: "60px",
              height: "calc(var(--vh, 1vh) * 100 - 114px)",
              display: "block",
              [`@media (min-width:${breakpoints.desktopMin})`]: {
                  display: "none",
              },
          }
        : {
              top: "25vh",
              height: "50vh",
              width: "80%",
              left: "10%",
              border: "2px solid var(--croonus-lightGray)",
              display: "block",
              [`@media (min-width:${breakpoints.desktopMin})`]: {
                  display: "none",
              },
          };

    const modalContent = (
            <Box className={`${styles.modal} ${bottomSheet ? styles.bottomSheet : ""} ${sideDrawer ? styles.sideDrawer : ""} ${filterPanel ? styles.filterPanel : ""}`}>
                <Box className={`${styles.modalTitleContainer} ${compactHeader ? styles.compactHeader : ""}`}>
                    {headerContent ?? (title && <h5 className={styles.modalTitle}>{title}</h5>)}
                    <button type="button" className={styles.closeButton} onClick={handleClose} aria-label="Zatvori">
                        <Icon>close</Icon>
                    </button>
                </Box>
                <Box className={styles.modalContent}>{children}</Box>
            </Box>
    );

    return (
        <Modal open={openModal} onClose={handleClose} hideBackdrop={!bottomSheet && !sideDrawer} closeAfterTransition={sideDrawer} sx={sx}>
            {sideDrawer ? (
                <Slide direction="left" in={openModal} timeout={{ enter: 280, exit: 220 }}>
                    <Box className={styles.sideDrawerShell}>
                        {sideRail}
                        {modalContent}
                    </Box>
                </Slide>
            ) : modalContent}
        </Modal>
    );
};

export default ModalWrapper;
